<template>
  <progress-circle
    circle-color="#ECE7E4"
    total-steps="100"
    inner-display="percent"
    :animation-duration="1000"
    :diameter="size"
    :completed-steps="value"
    :percent-color="font_color"
    :class="color"
  />
</template>

<script>
import { getColorByValue } from "@/utils";
import { ProgressCircle } from "vue-progress-circle";

export default {
  name: "Circle",
  components: { ProgressCircle },
  props: {
    value: {
      type: Number,
      required: true,
    },
    size: {
      type: Number,
      default: 108,
    },
    fontColor: {
      type: Boolean,
      default: false,
    }
  },
  computed: {
    color() {
      const options = {
        '#FE6944': 'red',
        '#FFC526': 'yellow',
        '#4BD37B': 'green'
      }
      return options[ getColorByValue(this.value) ];
    },

    font_color() {
      return this.fontColor
        ? getColorByValue(this.value)
        : 'black';
    }
  },
}
</script>

<style lang="scss">
.circle-progress-inner {
  overflow: hidden;
  max-width: 50%;
  span {
    font-size: 32px !important;
  }
}
.red svg.circle-progress-bar > circle:nth-child(3) {
  stroke: #FE6944 !important;
}
.yellow svg.circle-progress-bar > circle:nth-child(3) {
  stroke: #FFC526 !important;
}
.green svg.circle-progress-bar > circle:nth-child(3) {
  stroke: #4BD37B !important;
}
</style>